import { render, staticRenderFns } from "./ParametrosDados.vue?vue&type=template&id=22867f56&"
import script from "./ParametrosDados.vue?vue&type=script&lang=js&"
export * from "./ParametrosDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports